import { Button, elWFull, TextXS, Tile } from '@reapit/elements'
import React from 'react'

interface LastActionProps {
  lastActivity: string
  onViewActivity?: () => void
}

export const LastAction: React.FC<LastActionProps> = ({ lastActivity, onViewActivity }) => {
  return (
    <Tile>
      <TextXS hasBoldText hasMargin>
        Last Action
      </TextXS>
      <TextXS hasSectionMargin>{lastActivity}</TextXS>
      <Button onClick={() => onViewActivity?.()} className={elWFull}>
        View Activity
      </Button>
    </Tile>
  )
}
